export function usePurchaseInvoiceApi() {
  const { errors, request } = useRequestV2();

  async function getItemsOnProject(projectId: number, grouped: boolean, includeImages: boolean) {
    const url = `V3/PurchaseInvoice/GetItemsOnProject?projectId=${projectId}&grouped=${grouped}&includeImages=${includeImages}`;

    return await request<MaterialItemApp[]>(url);
  }

  async function addLocationItemsToProject(requestBody: AddLocationItemsToProjectRequestDTO) {
    const url = 'V3/PurchaseInvoice/AddLocationItemsToProject';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AddItemsToProjectResponseDTO>(url, requestOptions);
  }

  async function addCatalogItemsToProject(requestBody: AddCatalogItemsToProjectRequestDTO) {
    const url = 'V3/PurchaseInvoice/AddCatalogItemsToProject';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AddItemsToProjectResponseDTO>(url, requestOptions);
  }

  async function addPurchaseOrderItemsToProject(requestBody: AddPurchaseOrderItemsToProjectRequestDTO) {
    const url = 'V3/PurchaseInvoice/AddPurchaseOrderItemsToProject';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AddItemsToProjectResponseDTO>(url, requestOptions);
  }

  async function adjustRentOnProject(requestBody: AdjustRentItemsOnProjectRequestDTO) {
    const url = 'V3/PurchaseInvoice/AdjustRentOnProject';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AddItemsToProjectResponseDTO>(url, requestOptions);
  }

  async function createItemOnProject(requestBody: CreateItemOnProjectRequestDTO) {
    const url = 'V3/PurchaseInvoice/CreateItemOnProject';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<boolean>(url, requestOptions);
  }

  async function startRentOnProject(requestBody: StartRentItemsOnProjectRequestDTO) {
    const url = 'V3/PurchaseInvoice/StartRentOnProject';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AddItemsToProjectResponseDTO>(url, requestOptions);
  }

  return {
    errors,
    addLocationItemsToProject,
    addCatalogItemsToProject,
    addPurchaseOrderItemsToProject,
    adjustRentOnProject,
    getItemsOnProject,
    createItemOnProject,
    startRentOnProject
  };
}
